// plugins/toast.ts
import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin(async (nuxtApp) => {
  if (import.meta.client) {
    const OxiaClient = await import('@oxia/client');
    const { useDialog } = OxiaClient;

    // Inject useDialog function into the global app context
    nuxtApp.provide('useDialog', useDialog);
  }
});
